import React from "react";
import NewLink from "./NewLink";

export default function Navbar() {
    return (
        <header className="nav-container">
            <nav className="navbar">
                <NewLink to="./" content={<img width={"125"} height={"40"} src="./RockyTitle.png" alt="Logo de RockyBot" />} noRelink="true" />
                <ul className="links">
                    <li><NewLink content="Commandes" to="/commandes" /></li>
                    <li><NewLink content="Invite-moi" newPage="true" to="/invite" /></li>
                </ul>
            </nav>
        </header>
    );
};